import React from "react"
import BigCalendar from "react-big-calendar"
import moment from "moment"
import { MonthEvent, IShiftEvent } from "."
import { IScheduleDocument, IScheduleShift, IScheduleDailyTimelineData, IHolidayInstanceForPunch } from "../../../../models"
import "react-big-calendar/lib/css/react-big-calendar.css"
import "./styles.css"
import autobind from "class-autobind"
import EditIcon from "material-ui/svg-icons/image/edit"
import DeleteIcon from "material-ui/svg-icons/action/delete"
import AddShiftTemplateDialog from "../../../schedule/add_shift_template/AddShiftTemplateDialog"
import strings from "../../../../localization/strings"
import * as scheduleHelper from "../../../../helpers/scheduleHelper"
import * as timeHelper from "../../../../helpers/timeHelper"
import AppStateStore from "../../../../stores/AppStateStore"
interface IProps {
	schedules: IScheduleDocument[]
	refereceDate: Date
	readonly?: boolean
	holidays: IHolidayInstanceForPunch[]
	checkValidateNewTimeline(shifts: IScheduleShift[], updateShift: IScheduleShift, timelineItem: IScheduleDailyTimelineData): boolean
	handleDeleteShift(deleteShift: IScheduleShift): void
	handleUpdateShift(updateShift: IScheduleShift): void
}
interface IState {
	popupX: number
	popupY: number
	popupShift: IScheduleShift
	editShift: IScheduleShift
}
export default class UserDetailScheduleMonthly extends React.Component<IProps, IState> {
	constructor(props) {
		super(props)
		this.state = {
			popupX: null,
			popupY: null,
			popupShift: null,
			editShift: null,
		}
		autobind(this)
	}

	componentDidMount() {
		document.addEventListener("click", this.handleClickDocument)
	}

	componentWillUnmount() {
		document.removeEventListener("click", this.handleClickDocument)
	}

	handleClickDocument() {
		this.setState({ popupX: null, popupY: null, popupShift: null })
	}

	handleUpdateItem(updateShift: IScheduleShift) {
		this.setState({ editShift: null })
		const dayShifts: IScheduleShift[] = []
		this.props.schedules.forEach(schedule =>
			schedule.Schedules.forEach(pt =>
				pt.ShiftTemplates.forEach(st => {
					st.StartTime.Year === updateShift.StartTime.Year && st.StartTime.Month === updateShift.StartTime.Month && st.StartTime.Day === updateShift.StartTime.Day &&
						dayShifts.push(st)
				})
			)
		)

		const timelineItem: IScheduleDailyTimelineData = {
			StartTime: updateShift.StartTime,
			EndTime: updateShift.EndTime,
			Breaks: updateShift.Breaks
		}
		this.props.checkValidateNewTimeline(dayShifts, updateShift, timelineItem) &&
			this.props.handleUpdateShift(updateShift)
	}

	render() {
		const scheduleForMonth: IShiftEvent[] = []
		this.props.holidays && this.props.holidays.forEach(holiday => {
			scheduleForMonth.push({
				start: moment(timeHelper.keepConvertUTCToLocal(holiday.Holiday)).toDate(),
				end: moment(timeHelper.keepConvertUTCToLocal(holiday.Holiday)).toDate(),
				holidayName: holiday.HolidayName
			})
		})
		this.props.schedules.forEach(item =>
			item.Schedules.forEach(pt =>
				pt.ShiftTemplates.forEach(shift => {
					const dateTime = scheduleHelper.getTimeFromSimpleTime(shift.StartTime)
					moment(dateTime).isSameOrAfter(moment(this.props.refereceDate).startOf("month")) &&
						moment(dateTime).isSameOrBefore(moment(this.props.refereceDate).endOf("month")) &&
						scheduleForMonth.push({
							readonly: this.props.readonly,
							start: dateTime.hour(shift.StartTime.Hour).minute(shift.StartTime.Minute).toDate(),
							end: dateTime.hour(shift.EndTime.Hour).minute(shift.EndTime.Minute).toDate(),
							id: pt.Id,
							name: pt.Name,
							shift: shift,
							onRightClick: (shift: IScheduleShift, e: React.MouseEvent<HTMLElement>) =>
								this.setState({
									popupX: e.clientX,
									popupY: e.clientY,
									popupShift: shift
								})
						})
				})
			)
		)

		return (
			<div>
				<BigCalendar
					popup
					views={{ month: true, week: false }}
					defaultView={BigCalendar.Views.MONTH}
					step={60}
					className={"Calendar-container"}
					localizer={BigCalendar.momentLocalizer(moment)}
					events={scheduleForMonth}
					defaultDate={this.props.refereceDate}
					eventPropGetter={(_event) => ({ className: "Calendar-Event-Node" })}
					toolbar={false}
					components={{
						month: { event: MonthEvent }
					}}
				/>
				{this.state.popupShift && (!this.state.popupShift.PunchInTime || !this.state.popupShift.PunchOutTime) &&
					<div
						style={{
							position: "fixed", top: this.state.popupY, left: this.state.popupX, backgroundColor: "white", color: "rgba(97, 97, 97, 0.8)",
							boxShadow: "1px 1px 5px rgba(224, 224, 224, 0.5)", width: 110, zIndex: 1000, cursor: "default"
						}}
					>
						<div
							style={{ borderBottom: "1px solid rgb(224, 224, 224)", paddingTop: 10, paddingBottom: 7, display: "flex" }}
							onMouseDown={(e) => {
								e.stopPropagation()
								this.setState({
									editShift: this.state.popupShift
								})
							}}
						>
							<div><EditIcon style={{ height: 17, width: 17, marginLeft: 10, marginRight: 10 }} /></div>
							<div>{strings.Edit}</div>
						</div>
						{!this.state.popupShift.Used &&
							<div
								style={{ paddingTop: 10, display: "flex" }}
								onMouseDown={(e) => {
									e.stopPropagation()
									AppStateStore.setConfirmDialogContent({
										content: strings.Are_you_sure_you_want_to_remove_this_shift_template,
										confirm: () => this.props.handleDeleteShift(this.state.popupShift)
									})
								}}
							>
								<div><DeleteIcon style={{ height: 17, width: 17, marginLeft: 10, marginRight: 10 }} /></div>
								<div>{strings.Remove}</div>
							</div>
						}
					</div>
				}
				{this.state.editShift &&
					<AddShiftTemplateDialog
						editShiftTemplate={this.state.editShift}
						handleClose={() => this.setState({ editShift: null })}
						handleUpdate={this.handleUpdateItem}
					/>
				}
			</div>
		)
	}
}
